export class Link {
    constructor(
        public title: string = "",
        public url: string = ""
    ) {}
}
